/* paws | navigation behaviour.

   Two jobs:
   1. Close the desktop Shop panel on an outside click or Escape.
   2. Mount the paws phone drawer into Horizon's own drawer panel, so Horizon
      keeps the open, close and focus handling while paws owns the contents.

   WHY THE COLOURS ARE SET HERE. Horizon styles links inside its drawer white,
   for a dark drawer, and it wins even against an !important rule in the paws
   stylesheet, so every row came out white on white. An inline style written
   from script is the one thing that beats it. Do not tidy this back into the
   stylesheet, it does not hold. If the panel is never found, Horizon's own
   Main menu shows instead, which is a working fallback rather than an empty
   drawer. */
(function () {
  var NAVY = '#435D96';

  var d = document.querySelector('.paws-nav__drop');
  if (d) {
    document.addEventListener('click', function (e) {
      if (!d.contains(e.target)) d.removeAttribute('open');
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') d.removeAttribute('open');
    });
  }

  var src = document.getElementById('paws-drawer-src');
  if (!src) return;

  function paint(root) {
    root.querySelectorAll('a, b, small, span, em, p').forEach(function (el) {
      el.style.setProperty('visibility', 'visible', 'important');
    });
    root.querySelectorAll('a').forEach(function (a) {
      a.style.setProperty('color', NAVY, 'important');
    });
  }

  function mount() {
    var panel = document.querySelector('.menu-drawer__navigation') ||
                document.querySelector('.menu-drawer .menu-list') ||
                null;
    if (!panel) return;
    if (panel.getAttribute('data-paws-drawer') !== '2') {
      panel.innerHTML = src.innerHTML;
      panel.setAttribute('data-paws-drawer', '2');
    }
    paint(panel);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', mount);
  } else {
    mount();
  }
  document.addEventListener('click', function (e) {
    if (e.target.closest && e.target.closest('.header__icon--menu, .menu-drawer-container summary')) {
      setTimeout(mount, 20);
      setTimeout(mount, 260);
    }
  }, true);
})();